<template>
  <v-form ref="form" v-model="valid">
    <v-dialog v-model="show" max-width="500">
      <v-card>
        <v-card-title class="headline" primary-title>
          Select Subscription
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-select 
                  v-model="currentSubscription"
                  label="Subscription" 
                  required 
                  :items="atmosSubscriptions" 
                  item-text="name" 
                  return-object
                ></v-select>
              </v-flex>      
            </v-layout>
          </v-container>      
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="primary" @click.stop="handleClose">Change</v-btn>
          <v-btn flat color="primary" @click.stop="show=false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form>
</template>

<script>
import Vue from 'vue'
import store from '@/store'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'dialog-pick-subscription',
  
  data() {
    return {
      valid: false,
      currentSubscription: null,
    }
  },

  props: {
    value: Boolean,
  },

  computed: {
    ...mapGetters('atmos', [
      'atmosSubscription',
      'atmosSubscriptions'
    ]),

    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },

  watch: {
    show: function (val, oldVal) {
      if (val) {
        this.currentSubscription = this.atmosSubscription;
      }
    }
  }, 

  methods: {
    ...mapActions('atmos', [
      'atmosChangeSubscription'
    ]),
    
    async handleClose() {            
      var sub = this.atmosSubscriptions.find(i => i.id == this.currentSubscription.id);
      await this.atmosChangeSubscription(sub);
      //this.$router.push({ name: 'Dashboard'});
      this.show = false;
    }
  }
}
</script>